// Who is in the workspace (#806): `GET /api/v1/members`, read off
// `routes/members.py`. Team & roles lists it above the invitations.
//
// Who may read it is #806's decision, and the API's: a refusal arrives as a 403
// in words, which the section shows as said.

import type { Api } from "./http";

export const MEMBERS_PATH = "/api/v1/members";

/** One member of the workspace (`auth/members.py::Members.list`). */
export interface MemberRow {
  user_id: string;
  /** The display name, or null when the person gave none. */
  name: string | null;
  email: string;
  role: string;
  joined_at: string;
  /** The last sign-in, or null for somebody who has never signed in. */
  last_active_at: string | null;
}

export const listMembers = (api: Api): Promise<MemberRow[]> => api.get<MemberRow[]>(MEMBERS_PATH);

/**
 * Take a member out of the workspace, or yourself (#584): `DELETE /api/v1/members/{id}`,
 * answered 204. Who may is the route's rule; a refusal arrives in its words.
 */
export const removeMember = (api: Api, userId: string): Promise<void> =>
  api.delete<void>(`${MEMBERS_PATH}/${encodeURIComponent(userId)}`);

/** What removing a member would stop (#584): `GET /api/v1/members/{id}/removal`. */
export interface RemovalReach {
  api_keys: number;
  invitations: number;
}

export const readRemoval = (api: Api, userId: string): Promise<RemovalReach> =>
  api.get<RemovalReach>(`${MEMBERS_PATH}/${encodeURIComponent(userId)}/removal`);
